const getBrandName = () => {
  const currentUrl = window.location.href;
  const brandMatch = currentUrl.match(/umbro|fila|newbalance/);
  return brandMatch ? brandMatch[0] : 'fila';
};

export const brandConfig = {
  brandName: getBrandName(),
	brandSiteUrl: `https://www.${getBrandName()}.com.br`,
  
  brandCodeAdmin: () => {
    const codes = {
      umbro: '1',
      fila: '9',
      newbalance: '157'
    };
    return codes[getBrandName()] || 'UMBRO';
  },

  brandCodeSac: () => {
    const codes = {
      umbro: '1',
      fila: '2',
      newbalance: '4'
    };
    return codes[getBrandName()] || '1';
  },

  brandColor: () => {
    const colors = {
      umbro: '#000000',
      fila: '#19191A',
      newbalance: '#000000'
    };
    return colors[getBrandName()] || '#000000';
  },

  brandFolder: () => {
    const folders = {
      umbro: 'umbro',
      fila: 'fila',
      newbalance: 'new_balance'
    };
    return folders[getBrandName()] || 'fila';
  },

	brandImage: (imgPath, imgName, imgType) => {
		const brand = brandConfig.brandFolder();
		const url = `https://intercom.grupodass.com.br/rsc/intercom/img/ecommerce/voucher/${brand}/${imgPath}/${imgName}.${imgType}`;
		return encodeURI(url);
	},

  brandSocialMedia: {
    facebook: () => {
      const links = {
        umbro: 'https://www.facebook.com/UmbroBrasil/?locale=pt_BR',
        fila: 'https://www.facebook.com/fila.br/?locale=pt_BR',
        newbalance: 'https://www.facebook.com/NewBalanceBrasil/?locale=pt_BR'
      };
      return links[getBrandName()];
    },
    instagram: () => {
      const links = {
        umbro: 'https://www.instagram.com/umbrobrasil',
        fila: 'https://www.instagram.com/filabr/',
        newbalance: 'https://www.instagram.com/newbalance/'
      };
      return links[getBrandName()];
    },
    linkedin: () => {
      const links = {
        umbro: 'https://uk.linkedin.com/company/umbro',
        fila: 'https://br.linkedin.com/company/fila',
        newbalance: 'https://www.linkedin.com/company/new-balance'
      };
      return links[getBrandName()];
    },
    youtube: () => {
      const links = {
        umbro: 'https://www.youtube.com/user/umbrobrasil',
        fila: 'https://www.youtube.com/channel/UC8TtevJjlaEYYyznejzkwfg',
        newbalance: 'https://www.youtube.com/@newbalancebrasil1488'
      };
      return links[getBrandName()];
    }
  }
};